// Copyright © 2025 The Things Industries B.V.

import { createSelector } from 'reselect'

import {
  createPaginationIdsSelectorByEntity,
  createPaginationTotalCountSelectorByEntity,
} from '@ttn-lw/lib/store/selectors/pagination'

const ENTITY = 'labels'

export const selectLabelStore = state => state.labels
export const selectLabelEntitiesStore = state => selectLabelStore(state).entities
export const selectLabelById = (state, id) => selectLabelEntitiesStore(state)[id]
export const selectSelectedLabelId = state => selectLabelStore(state).selectedLabel
export const selectSelectedLabel = state => selectLabelById(state, selectSelectedLabelId(state))
export const selectLabeledEntities = state => selectLabelStore(state).labelEntities
export const selectLabeledTotalCount = state => selectLabelStore(state).labeledTotalCount

const selectLabelsIds = createPaginationIdsSelectorByEntity(ENTITY)
const selectLabelsPaginationTotalCount = createPaginationTotalCountSelectorByEntity(ENTITY)

export const selectLabels = createSelector(
  [selectLabelsIds, selectLabelEntitiesStore],
  (ids, entities) => ids.map(id => entities[id]),
)
export const selectLabelsTotalCount = state => selectLabelsPaginationTotalCount(state)
